import { render, staticRenderFns } from "./FansBomb.vue?vue&type=template&id=39323739&scoped=true&"
import script from "./FansBomb.vue?vue&type=script&lang=js&"
export * from "./FansBomb.vue?vue&type=script&lang=js&"
import style0 from "./FansBomb.vue?vue&type=style&index=0&id=39323739&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39323739",
  null
  
)

export default component.exports